"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./SFAlert.css");
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var ErrorOutlineOutlined_1 = __importDefault(require("@material-ui/icons/ErrorOutlineOutlined"));
var CheckCircleOutlineOutlined_1 = __importDefault(require("@material-ui/icons/CheckCircleOutlineOutlined"));
var SFAlert = function (_a) {
    var showAlert = _a.showAlert, severity = _a.severity, title = _a.title, message = _a.message;
    if (!showAlert) {
        return null;
    }
    var icon;
    switch (severity) {
        case 'error':
            icon = react_1.default.createElement(ErrorOutlineOutlined_1.default, null);
            break;
        case 'info':
            icon = react_1.default.createElement(InfoOutlined_1.default, null);
            break;
        default:
            icon = react_1.default.createElement(CheckCircleOutlineOutlined_1.default, null);
    }
    return (react_1.default.createElement("div", { className: "sf-alert " + severity },
        react_1.default.createElement("div", { className: "icon-container" }, icon),
        react_1.default.createElement("div", { className: "alert-container" },
            react_1.default.createElement("div", { className: "alert" },
                react_1.default.createElement("div", { className: "title" }, title),
                react_1.default.createElement("div", { className: "message" }, message)))));
};
exports.default = SFAlert;
